import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import PageLayout from "./component/Event-Details/PageLayout";
import GetVenue from "./component/GetVenue/GetVenue";
import PlanForMe from "./component/PlanforMe/PlanForMe";
import SignUpForm from "./component/SignUpForm/SignUpForm";
import Soon from "./component/Soon/Soon";
import PrivacyPolicy from "./component/PrivacyPolicy/PrivacyPolicy";
import TermsOfUse from "./component/TermsOfUse/TermsOfUse";
import AboutUs from "./component/AboutUs/AboutUs";
import FAQ from "./component/FAQ/FAQ";
import ContactUs from "./component/ContactUs/ContactUs";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Soon />,
      title: "Quickplanners helps you plan events effortlessly — find trusted vendors, discover venues, or work with experienced planners, all in one place."
    },
    {
      path: "/register-vendor",
      element: <SignUpForm />,
      title: "Join Quickplanners to reach serious clients looking for reliable event vendors. Get verified, get seen, and grow your business.",
    },
    {
      path: "/plan-for-me",
      element: <PlanForMe />,
      title: "Let Quickplanners match you with verified planners and vendors who fit your event goals, style, and budget — we handle the search, you enjoy the results.",
    },
    {
      path: "/get-venue",
      element: <GetVenue />,
      title: "Skip the stress of venue hunting. Pay a small fee and get a curated list of verified venues that perfectly fit your event’s size, budget, and style."
    },
    {
      path: "/get-vendors",
      element: <PageLayout />,
      title: "Tell us your event needs, and we’ll connect you with the right vendors — from decorators to caterers — fast, easy, and worry-free."
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
      title: "Privacy Policy - Quickplanners"
    },
    {
      path: "/terms-of-use",
      element: <TermsOfUse />,
      title: "Terms of Use - Quickplanners"
    },
    {
      path: "/about-us",
      element: <AboutUs />,
      title: "About Us - Quickplanners"
    },
    {
      path: "/faq",
      element: <FAQ />,
      title: "FAQ - Quickplanners"
    },
    {
      path: "/contact-us",
      element: <ContactUs />,
      title: "Contact Us - Quickplanners"
    },
  ]);
  return (
    <HelmetProvider>
      <div className="App">
      <RouterProvider router={router} />
    </div>
    </HelmetProvider>
      );
}

export default App;
